/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Danger_ZoneInputs */

const en_profile_danger_zone = /** @type {(inputs: Profile_Danger_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danger zone`)
};

const es_profile_danger_zone = /** @type {(inputs: Profile_Danger_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona de peligro`)
};

/**
* | output |
* | --- |
* | "Danger zone" |
*
* @param {Profile_Danger_ZoneInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_danger_zone = /** @type {((inputs?: Profile_Danger_ZoneInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Danger_ZoneInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_danger_zone(inputs)
	return en_profile_danger_zone(inputs)
});